import React, { useState, useEffect } from "react";
import {
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Box,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import UseQsButton from "./utils/UseQsButton";

const kitchenTypes = [
  { name: "Hotell", type: "H", F: 5, VM: 100 },
  { name: "Restaurant", type: "R", F: 8.5, VM: 50 },
  { name: "Sykehus", type: "S", F: 13, VM: 20 },
  { name: "Kantine", type: "K", F: 20, VM: 5 },
  { name: "Catering med heldagsproduksjon", type: "C", F: 22, VM: 10 },
];

function KitchenTypeCalculator({handleSetQs}) {
  const [selectedType, setSelectedType] = useState("");
  const [mealsPerDay, setMealsPerDay] = useState("");
  const [avgHours, setAvgHours] = useState("");
  const [Qs, setQs] = useState(0);
  const [F, setF] = useState("")
  const [waterUsagePerMeal, setWaterUsagePerMeal] = useState("")

  useEffect(() => {
    const kitchenType = kitchenTypes.find((k) => k.type === selectedType);
    if (!kitchenType || !mealsPerDay || !avgHours) {
      setQs(0);
      setWaterUsagePerMeal("")
      setF("")
      return;
    }

    setWaterUsagePerMeal(kitchenType.VM)
    setF(kitchenType.F);

    const calculatedQs =
      mealsPerDay * waterUsagePerMeal * (F / (avgHours * 3600));

    setQs(calculatedQs.toFixed(2));
  }, [selectedType, mealsPerDay, avgHours, F, waterUsagePerMeal]);

  return (
    <>
      <UseQsButton Qs={Qs} handleSetQs={handleSetQs}/>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <InputLabel>Velg kjøkkentype</InputLabel>
            <Select
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
              label="Velg kjøkkentype"
            >
              {kitchenTypes.map((type) => (
                <MenuItem key={type.type} value={type.type}>
                  {type.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Antall måltider per dag"
            type="number"
            fullWidth
            value={mealsPerDay}
            onChange={(e) => setMealsPerDay(e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Gjennomsnittlig driftstid pr. dag (timer)"
            type="number"
            fullWidth
            value={avgHours}
            onChange={(e) => setAvgHours(e.target.value)}
          />
        </Grid>

        <Grid item xs={12}>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Vannforbruk pr. produsert varmretter pr. dag</TableCell>
                  <TableCell>Maks vannføringsfaktor (F)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{F || "-"}</TableCell>
                  <TableCell>
                    {waterUsagePerMeal || "-"}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </>
  );
}

export default KitchenTypeCalculator;
